Customer.Users ||= {}

class Customer.Users.WhatsappProfileView extends Backbone.View

  template: JST["backbone/templates/customer/users/whatsapp_profile"]

  className: 'social-profile'
  id: 'whatsapp-profile'

  events:
    'click .remove-profile-button': 'removeSocialUser'

  initialize: (socialUser) ->
    @socialUser = socialUser

  render: ->
    @$el.html(@template(socialUser: @socialUser))
    @

  removeSocialUser: ->
    @trigger('profile:remove-social-user', @socialUser)
